// extracted by mini-css-extract-plugin
export var container = "styles-module--container--9295b";
export var icon = "styles-module--icon--fd62d";